/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { IColumn, ConstrainMode, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { connect } from 'react-redux';
import { showDialog, showToastMessage } from '../../Dialog/actions';
import { IUserProfile } from '../../Auth/types';
import Helper from '../../../core/libraries/Helper';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import ListActionsMenu from '../../../core/common/ListActionsMenu';
import { RootState } from '../../../store/store';
import { IAccountReport } from '../types';
import DetailsListWrapper from '../../../core/components/DetailsListWrapper/DetailsListWrapper';
import { DirectionalHint, IListProps, Link, ShimmeredDetailsList, TooltipHost } from '@fluentui/react';
import Configuration from '../../../core/libraries/Configuration';
import { getIncompleteUploads } from '../services';
import Template from '../../../core/libraries/Template';
import RbButton, { ButtonSize, ButtonType } from '../../../bosch-react/components/button/RbButton';
import _ from 'lodash';

interface MyInCompleteUploadsProps {
    userProfile: IUserProfile | undefined,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage,
}

interface IState {
    isAdminMode: boolean,
    incompleteReports: IAccountReport[] | null,
    filteredItems: IAccountReport[] | null,
    selectedItem: any,
    showWorkflowIdDialog: boolean,
    columns: IColumn[]
}

class MyInCompleteUploads extends React.Component<MyInCompleteUploadsProps, IState> {

    private timeoutId: NodeJS.Timeout | null = null;

    private _onClickRestartUpload(item: IAccountReport) {
        Helper.openNewTab(`${process.env.REACT_APP_ACCESS_MEDIATOR}/${item.id}`);
    }


    constructor(props: MyInCompleteUploadsProps) {
        super(props);
        this.state = {
            selectedItem: null,
            showWorkflowIdDialog: false,
            isAdminMode: false,
            incompleteReports: null,
            columns: [...this.normalModeColumns, ...this.actionColumns],
            filteredItems: null
        };
    }

    componentDidMount() {
        Helper.runNewTask(() => {
            this.getIncompleteUploads();
        });
    }

    changeMode() {
        this.setState({
            isAdminMode: !this.state.isAdminMode
        }, () => {
            Helper.runNewTask(async () => {
                await this.getIncompleteUploads();
            });
        })
    }

    _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey as keyof T;
        return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    }

    private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { filteredItems } = this.state;
        const newColumns: IColumn[] = this.normalModeColumns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newItems = this._copyAndSort(filteredItems ?? [], currColumn.fieldName!, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            filteredItems: newItems,
        });
    };

    shimmeredDetailsListProps: IListProps = {
        renderedWindowsAhead: 0,
        renderedWindowsBehind: 0,
    };


    normalModeColumns: IColumn[] = [
        {
            key: 'title',
            name: 'Title',
            fieldName: 'Title',
            currentWidth: Helper.resizeColumnByScreenWidth(10),
            minWidth: Helper.resizeColumnByScreenWidth(10),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onColumnClick: this._onColumnClick,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onRender: (item: IAccountReport) => {
                return (
                    <Link target='_blank' href={Helper.generateAccessMediatorUrl(item.id)}>{item.title}</Link>
                );
            }
        },
        {
            key: 'authors',
            name: 'Author(s)',
            fieldName: 'Authors',
            currentWidth: Helper.resizeColumnByScreenWidth(12),
            minWidth: Helper.resizeColumnByScreenWidth(12),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onRender: (item: IAccountReport) => {
                const authors = item.author ? item.author.split(",") : [];
                return Template.renderReadOnlyPeople(authors);
            }
        },
        {
            key: 'basicProps',
            name: 'Basic Information',
            fieldName: 'Basic Information',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            onRender: (item: IAccountReport) => {
                return (
                    <>
                        <RbLabel isInline={false} size={LabelSize.Small} >Division: <strong>{item.division}</strong></RbLabel>
                        <RbLabel isInline={false} size={LabelSize.Small} >Department: <strong>{item.department}</strong></RbLabel>
                        <RbLabel isInline={false} size={LabelSize.Small} >Upload Type: <strong>{item.uploadType}</strong></RbLabel>
                    </>
                );
            }
        },
        {
            key: 'keywords',
            name: 'Keywords',
            fieldName: 'Keywords',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IAccountReport) => {
                return (
                    <TooltipHost
                        directionalHint={DirectionalHint.leftCenter}
                        content={item.keywords}>
                        {item.keywords}
                    </TooltipHost>
                );
            }
        },
    ];

    adminModeColumns: IColumn[] = [
        {
            key: 'submitter',
            name: 'Submitter',
            fieldName: 'Submitter',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IAccountReport) => {
                return Template.renderReadOnlyPeople([item.createdBy]);
            }
        },
        {
            key: 'correlationId',
            name: 'Correlation ID',
            fieldName: 'CorrelationId',
            currentWidth: Helper.resizeColumnByScreenWidth(8),
            minWidth: Helper.resizeColumnByScreenWidth(8),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IAccountReport) => {
                return (
                    <TooltipHost
                        directionalHint={DirectionalHint.leftCenter}
                        content={item.correlationId}>
                        <RbLabel size={LabelSize.Small} >{item.correlationId}</RbLabel>
                    </TooltipHost>
                );
            }
        }
    ]

    actionColumns: IColumn[] = [
        {
            key: 'workflowId',
            name: 'Workflow ID',
            fieldName: 'WorkflowId',
            currentWidth: Helper.resizeColumnByScreenWidth(10),
            minWidth: Helper.resizeColumnByScreenWidth(10),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            onRender: (item: IAccountReport) => {
                return (
                    (this.state.isAdminMode === true) ?
                        <RbButton disabled type={ButtonType.Secondary} size={ButtonSize.Small} label={
                            (item.workflowId !== "" && !_.isNil(item.workflowId)) ?
                                item.workflowId : "..."}
                            title="Click here to edit this Workflow ID" />
                        : <RbLabel size={LabelSize.Small} >{item.workflowId}</RbLabel>
                );
            }
        },
        {
            key: 'restartUpload',
            name: '',
            fieldName: 'Actions',
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            isRowHeader: true,
            isPadded: true,
            isMultiline: true,
            onRender: (item: IAccountReport) => {
                return (
                    <RbButton label="Restart Upload" size={ButtonSize.Small} onClick={() => {
                        this._onClickRestartUpload(item)
                    }
                    } />
                );
            }
        }
    ]

    async getIncompleteUploads() {
        this.setState({
            filteredItems: null
        })
        let incompleteReports: IAccountReport[] = []
        try {
            incompleteReports.push(...await getIncompleteUploads(this.state.isAdminMode));
            this.setState({
                incompleteReports: incompleteReports,
                filteredItems: incompleteReports
            })
        } catch (error) {
            this.props.showDialog(false)
        }
    }

    private _onChangeText = (text: string): void => {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
            this.setState({
                filteredItems: text ? [...this.state.incompleteReports ?? []].filter(i => i.title && i.title.toLowerCase().indexOf(text.toLowerCase()) > -1
                    || i.keywords && i.keywords.toLowerCase().indexOf(text.toLowerCase()) > -1
                    || i.workflowId && i.workflowId.toLowerCase().indexOf(text.toLowerCase()) > -1) : [...this.state.incompleteReports ?? []],
            });
        }, 500);
    };

    render() {
        let { filteredItems } = this.state
        let modeColumns = !!this.state.isAdminMode && [...this.normalModeColumns, ...this.adminModeColumns, ...this.actionColumns] || [...this.normalModeColumns, ...this.actionColumns]
        let element = (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm1" />
                    <div className="ms-Grid-col ms-sm10">

                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <RbLabel className="header-title" size={LabelSize.Large}> My Canceled/Rejected Uploads </RbLabel>
                                <ListActionsMenu
                                    columns={modeColumns}
                                    items={filteredItems || []}
                                    searchText={(value: any) => { this._onChangeText(value) }}
                                    showAdminResults={this.state.isAdminMode}
                                    getAdminData={() => {
                                        this.changeMode();
                                    }}></ListActionsMenu>
                            </div>
                            <DetailsListWrapper>
                                <ShimmeredDetailsList
                                    setKey="set"
                                    compact={true}
                                    items={filteredItems || []}
                                    constrainMode={ConstrainMode.unconstrained}
                                    columns={modeColumns}
                                    selectionMode={SelectionMode.single}
                                    enableShimmer={!filteredItems}
                                    ariaLabelForShimmer="Content is being fetched"
                                    ariaLabelForGrid="Pending report detail"
                                    listProps={this.shimmeredDetailsListProps}
                                    onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                                    onShouldVirtualize={() => { return true }}
                                />
                            </DetailsListWrapper>
                        </div>

                    </div>
                    <div className="ms-Grid-col ms-sm1" />
                </div>
            </div>
        );
        return element;
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps, {
    showDialog,
    showToastMessage,
})(MyInCompleteUploads);